import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './OrderStatus.module.scss'
import routes from '../../../routes'
import Button from '../../Button';
import Typography from "../../Typography";

export default function OrderStatusForm({
                                          setExternalOrderId = undefined,
                                          setExternalStudentFirstName = undefined,
                                          setExternalStudentLastName = undefined,
                                          setExternalEmail = undefined,
                                          onSubmit = undefined,
                                          requireOrderId = false,
                                        }) {
  const [orderId, setOrderId] = useState('')
  const [email, setEmail] = useState('')
  const [studentFirstName, setStudentFirstName] = useState('')
  const [studentLastName, setStudentLastName] = useState('')

  const history = useHistory()

  const handleSubmit = (e) => {
    e.preventDefault()

    history.push(routes.orderStatus({ email, orderId, studentFirstName, studentLastName }))
  }

  return (
    <form className={styles.form} onSubmit={onSubmit || handleSubmit}>
      <Typography align="center" tag="h1" weight="bold">
        Enter your email and your student name or Order Confirmation Number that was used to purchase
      </Typography>

      <hr />
      <label>
        Email
        <input type="email" required value={email} onChange={(e) => (setExternalEmail && setExternalEmail(e.target.value)) || setEmail(e.target.value)} />
      </label>
      <label>
        Student First Name
        <input type="student_first_name" required value={studentFirstName} onChange={(e) => (setExternalStudentFirstName && setExternalStudentFirstName(e.target.value)) || setStudentFirstName(e.target.value)} />
      </label>
      <label>
        Student Last Name
        <input type="student_last_name" required value={studentLastName} onChange={(e) => (setExternalStudentLastName && setExternalStudentLastName(e.target.value)) || setStudentLastName(e.target.value)} />
      </label>
      <label>
        Order ID{!requireOrderId && ' (optional)'}
        <input value={orderId} required={requireOrderId} onChange={(e) => (setExternalOrderId && setExternalOrderId(e.target.value)) || setOrderId(e.target.value)} />
      </label>
      {requireOrderId && (
        <p className={styles.securityNote}>
          For the security of your child's images, please enter your Order ID. You can find it in your order confirmation email.
        </p>
      )}
      <div style={{ marginTop: '16px' }}>
        <Button fullWidth type="submit" variant="primary">Search</Button>
      </div>
    </form>
  )
}
